export default __webpack_public_path__ + "ea5c2335af673531190a11cf3a60dcab.svg";